// extracted by mini-css-extract-plugin
export default {"botao":"Button_botao__JYb-j","active":"Button_active__HcGU9"};